import { getBooleanValue } from '../../../shared/api/session/getBooleanValue.js';
import { getUserInfo } from '../api/getUserInfo.js';

const MINIMUM_RESOLUTION = 360;
const WEB_OPTION_MOBILE_ACCESS = 'userSecurityWebOptions.MOBILE.ACCESS';

export async function validateResolution() {
  if (screen.availWidth > MINIMUM_RESOLUTION && screen.availHeight > MINIMUM_RESOLUTION) {
    return Promise.resolve(true);
  }

  const value = await getUserInfo(WEB_OPTION_MOBILE_ACCESS, true);
  return getBooleanValue(value);
}
